import React from 'react';
import { PV04FormField } from './types';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

interface DynamicFieldProps {
  schema: PV04FormField;
  value: string;
  onChange: (name: string, value: string) => void;
  isVisible: boolean;
  error?: string;
  validateField: (field: PV04FormField, value: string) => boolean;
}

export const DynamicFormField: React.FC<DynamicFieldProps> = ({
  schema,
  value,
  onChange,
  isVisible,
  error,
  validateField,
}) => {
  const { name, type, renderType, selectOption, description } = schema;
  const { t } = useTranslation();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const newValue = e.target.value;

    // // 입력 필터 적용
    // if (inputFilter && !inputFilter(newValue)) {
    //   return;
    // }

    onChange(name, newValue);
  };

  const isValid = validateField(schema, value);

  const renderInput = () => {
    switch (renderType) {
      case `select_${name}`:
        return (
          <ReactSelect
            value={selectOption?.find(option => option.value === value)}
            onChange={selectedOption =>
              onChange(name, selectedOption?.value || '')
            }
            options={selectOption}
            className={`react-select ${isValid ? 'valid' : 'invalid'}`}
            classNamePrefix="react-select"
            placeholder={t(`select_${name}`)}
            tabIndex={isVisible ? 0 : -1}
          />
        );
      default:
        return (
          <input
            type={type}
            value={value}
            onChange={handleChange}
            className={`form-input ${isValid ? 'valid' : 'invalid'}`}
            tabIndex={isVisible ? 0 : -1}
            readOnly={!isVisible}
          />
        );
    }
  };

  return (
    <ul className="depth-1">
      <li className={`dynamic-field-item ${isVisible ? 'visible' : 'hidden'}`}>
        <div className="sub-title">
          {t(name)}
          {description && `(${description})`}
          <span className="redstar">*</span>
        </div>
        <div className="dynamic-input">
          {renderInput()}
          {error && <span className="error-message">{error}</span>}
        </div>
      </li>
    </ul>
  );
};
